const SAFE_HREF = /^(https?:|mailto:)/i;

function escapeHtmlChars(s: string) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/** Decodes HTML entities and escapes all tags except safe <a> links to plain text. */
export function decodeHtml(str: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;

  return txt.value
    .split(/(<\/?[a-z][^>]*>)/gi)
    .map((part, i) => {
      if (i % 2 === 0) return escapeHtmlChars(part);
      if (/^<\/a>/i.test(part)) return '</a>';
      if (/^<a[\s>]/i.test(part)) {
        const href = part.match(/href="([^"]*)"/i)?.[1] ?? '';
        return SAFE_HREF.test(href)
          ? `<a href="${escapeHtmlChars(href)}">`
          : '<a>';
      }
      return escapeHtmlChars(part);
    })
    .join('');
}
